import React from "react";

import Layout from "../../Layout";
import * as UI from "./ui";
import { DateTime } from 'luxon';

const Subheader = ({ greeting, authToken, setAuthToken }) => {
  const asOfDate = `As of ${DateTime.local().toFormat("MMM dd, yyyy hh:mm a")}`;

  const handleLogout = (e) => {
    setAuthToken(null);
    window.location.reload();
  };

  return (
    <UI.Background>
      <UI.Layout>
        <Layout.FullWidth alignItems="center">
          <Layout.FlexibleColumn span={[7,15]} breakpoint="belowTablet" spaced>
            <UI.Row>
              <UI.Greeting>Entries for: {greeting}</UI.Greeting>
              <UI.FormattedDate>{asOfDate}</UI.FormattedDate>
              {authToken && (
                <UI.Button onClick={handleLogout}>Log Out</UI.Button>
              )}
            </UI.Row>
          </Layout.FlexibleColumn>
        </Layout.FullWidth>
      </UI.Layout>
    </UI.Background>
  );
};

export default Subheader;
